import { render, staticRenderFns } from "./collection-order.vue?vue&type=template&id=22c2fe50&scoped=true&"
import script from "./collection-order.vue?vue&type=script&lang=ts&"
export * from "./collection-order.vue?vue&type=script&lang=ts&"
import style0 from "./collection-order.vue?vue&type=style&index=0&id=22c2fe50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c2fe50",
  null
  
)

export default component.exports